// Constants for form checking configuration
const FORM_CHECK_CONFIG = {
  INTERVAL: 100,  // Time between attempts in milliseconds
  MAX_ATTEMPTS: 15 // Maximum number of retry attempts
};

const SELECTORS = {
  // Product variant selectors
  VARIANT_ID: 'input[type="hidden"][name="id"]',
  VARIANT_SIZE: 'input[name="Size" i]:checked',
  
  // Product information selectors
  PRODUCT_ID: 'input[type="hidden"][name="product-id"]',
  PRODUCT_TITLE: '[data-testid="pdpProductTitle"]',
  
  // Shopify section for Forms App form 
  FORM_EMBED: 'shopify-forms-embed',
  FORM_EMBED_ACTIVE: 'shopify-forms-embed.show',
  FORM_SECTIONS: 'div.shopify-block[id*="forms_inline"]',
  
  // Form input selectors (within shadow root)
  FORM_VARIANT_ID: 'input[id*="variant_id"]',
  FORM_VARIANT_TITLE: 'input[id*="variant_title"]',
  FORM_PRODUCT_ID: 'input[id*="product_id"]',
  FORM_PRODUCT_TITLE: 'input[id*="product_title"]',
  
  // Size selection element
  SIZE_SELECTOR: 'variant-radios',
  SIZE_SELECTOR_SIZES: 'variant-sizes',
  SIZE_SELECTOR_OOS_NO_VARIANTS: 'product-form form button:disabled',

  // Styles element selector
  CUSTOM_STYLES: 'style[data-custom-styles]',

  // Add to cart button selector
  ADD_TO_CART_FORM: '.product product-form',
  ADD_TO_CART_SQUARE: '.product square-placement',
  ADD_TO_CART_INFO: '.product .product-form__text'
};

// CSS Styles for the shadow-root element
const FORM_STYLES = `
  form  {
    margin-top: 1px;
  }
  form input {
    font-size: 12px !important;
  }
  form input:focus-visible {
    font-size: 12px !important;
    outline-width: 2px !important;
    outline-style: auto !important;
    outline-color: #111 !important;
    outline-offset: 0 !important;
    box-shadow: none !important;
  }
  form label {
    height: 100%;
    display: flex;
    align-items: center;
    top: 0 !important;
    font-size: 12px !important;
  }
  /* Form success message */
  section h2 {
    font-size: 14px;
    justify-content: flex-start !important;
  }
  section div[class*="textBody"] {
    font-size: 12px;
    text-align: left;
  }
  /* label message */
  section:has(~ form) p{
    font-size: 12px;
    color: #AD0B55;
    text-align: left;
    margin: -7px 0px -9px 0px !important;
  }
  /* Hides all form inputs except email field */
  form[novalidate] > div:nth-last-child(-n+5)  {
    display: none !important;
  }
  form[novalidate] p  {
    font-size: 12px;
    text-align: left;
    margin: 0px 0px -9px 0px !important;
  }

  /* Removes the rounded corners & fixes font from the input, button */
  button, input {
    border-radius: 0px !important;
    font-family: 'Graphik-Regular', sans-serif !important;
  }
  button {
    font-size: 12px !important;
  }
`;

// Populates the out-of-stock/future-release form with product and variant information
const fillOutOutOfStockOrFutureReleaseForm = (formEmbedShadowRoot) => {
  try {
    
    // Check if styles already exist so to not add them again
    if (!formEmbedShadowRoot.querySelector(SELECTORS.CUSTOM_STYLES)) {
      // Inserts the styles into the Forms App shadow root element
      const styleElement = document.createElement('style');
      styleElement.setAttribute('data-custom-styles', '');
      styleElement.textContent = FORM_STYLES;
      formEmbedShadowRoot.appendChild(styleElement);
    }

    // Get product and variant information from the page
    const productInfo = {
      variantId: document.querySelector(SELECTORS.VARIANT_ID)?.value?.trim(),
      variantTitle: document.querySelector(SELECTORS.VARIANT_SIZE)?.value?.trim() || 'no-variant',
      productId: document.querySelector(SELECTORS.PRODUCT_ID)?.value?.trim(),
      productTitle: document.querySelector(SELECTORS.PRODUCT_TITLE)?.textContent?.trim()
    };

    // Set variant information in the form
    const formInputs = {
      variantId: formEmbedShadowRoot.querySelector(SELECTORS.FORM_VARIANT_ID),
      variantTitle: formEmbedShadowRoot.querySelector(SELECTORS.FORM_VARIANT_TITLE),
      productId: formEmbedShadowRoot.querySelector(SELECTORS.FORM_PRODUCT_ID),
      productTitle: formEmbedShadowRoot.querySelector(SELECTORS.FORM_PRODUCT_TITLE)
    };

    // Update form inputs and trigger input events
    Object.entries(formInputs).forEach(([key, input]) => {
      if (input && productInfo[key]) {
        input.value = productInfo[key];
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

  } catch (error) {
    console.error('Error setting product values:', error);
  }
};

// Toggle visibility of add to cart button and its info section
const displayAddToCartButton = (show) => {
  try {
      // Get elements
      const infoPlacement = document.querySelector(SELECTORS.ADD_TO_CART_INFO);
      const productForm = document.querySelector(SELECTORS.ADD_TO_CART_FORM);
      const squarePlacement = document.querySelector(SELECTORS.ADD_TO_CART_SQUARE);

      // Toggle square placement visibility
      if (squarePlacement) {
        squarePlacement.style.display = show ? 'block' : 'none';
    }

    // Toggle add to cart info visibility
    if (infoPlacement) {
      infoPlacement.style.display = show ? 'block' : 'none';
    }
  
      // Toggle product form parent div visibility
      if (productForm) {
          const parentDiv = productForm.closest('div');
          if (parentDiv) {
              parentDiv.style.display = show ? 'block' : 'none';
          }
      }
  } catch (error) {
      console.error('Error toggling add to cart button visibility:', error);
  }
}

// Gets the pdp size selector component
const getSizeSelector = () => document.querySelector(SELECTORS.SIZE_SELECTOR) || document.querySelector(SELECTORS.SIZE_SELECTOR_SIZES);

// Function to hide all form embeds by removing the 'show' class
const hideAllForms = () => document.querySelectorAll(SELECTORS.FORM_EMBED_ACTIVE).forEach(el => el.classList.remove('show'));

// Function to determine the form key based on the selected size
const getFormKey = (selectedSize) => {
  if (selectedSize.classList.contains('raffle-online')) return "online drawing";
  if (selectedSize.classList.contains('raffle-store')) return "store drawing";
  if (selectedSize.classList.contains('pre-order')) return "pre-order";
  if (selectedSize.classList.contains('future-release')) return "coming soon";
  if (selectedSize.classList.contains('out-of-stock')) return "out of stock";
  return null;
};

document.addEventListener('DOMContentLoaded', function() {
  let attempts = 0;

  // Main function to handle form setup and visibility for form
  const setUpFormsAppFormsForProduct = () => {
    const selectedSize = document.querySelector(SELECTORS.VARIANT_SIZE);
    if (!selectedSize) return;

    const formKey = getFormKey(selectedSize);
    if (formKey) {
      // Out-of-order, future-release or out-of-stock product
      handleSpecialProductForm(formKey);
    } else {
      // Standard product
      handleStandardProductForm();
    }
  };

  // Handle special product (out-of-stock, pre-order, future-release)
  const handleSpecialProductForm = (formKey) => {
    const formSections = document.querySelectorAll(SELECTORS.FORM_SECTIONS);
    const formFound = Array.from(formSections).some(section => {
      const formElement = section.querySelector(SELECTORS.FORM_EMBED);
      const formShadowRoot = formElement?.shadowRoot;
      const formContent = formShadowRoot?.textContent?.trim()?.toLowerCase() || '';

      if (formContent.includes(formKey)) {
        // Form found, sets up and displays it
        setTimeout(() => {
          hideAllForms();
          fillOutOutOfStockOrFutureReleaseForm(formShadowRoot);
          formElement.classList.add('show');
          displayAddToCartButton(false);
        }, FORM_CHECK_CONFIG.INTERVAL);
        return true;
      } else if (formContent.includes("success")) {
        // if the form was already submitted, reload the page so the form can re-render and show again
        location.reload();
        return true;
      }
      return false;
    });

    // Retries if form not found
    if (!formFound) {
      retryFormSetup();
    }
  };

  // Handle standard available product
  const handleStandardProductForm = () => {
    hideAllForms();
    displayAddToCartButton(true);
  };

  // Retry logic for form setup
  const retryFormSetup = () => {
    attempts++;
    if (attempts < FORM_CHECK_CONFIG.MAX_ATTEMPTS) {
      console.log(`Attempt ${attempts}: out-of-stock/future-release form not found, retrying...`);
      setTimeout(setUpFormsAppFormsForProduct, FORM_CHECK_CONFIG.INTERVAL);
    } else {
      console.log(`out-of-stock/future-release form not found after all ${FORM_CHECK_CONFIG.MAX_ATTEMPTS} attempts`);
    }
  };

  // Setup change/select size listener
  const setupSizeSelectionOnChange = () => {
    const sizeSelector = getSizeSelector();
    if (sizeSelector) {
      sizeSelector.addEventListener('change', (event) => {
        if (event.target.type === 'radio') {
          setUpFormsAppFormsForProduct();
        }
      });
    }
  };

  // Initial setup
  setUpFormsAppFormsForProduct();
  setupSizeSelectionOnChange();
});

